









































import { Component } from 'vue-property-decorator';
import AbstractDisplayField from './abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import BpcDrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import MandateForm from '@accounting/components/forms/mandate-form/mandate-form.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';

@Component({
  name: 'bpc-display-field-mandate',
  components: {
    'bpc-drawer-modal': BpcDrawerModal,
    'bc-mandate-form': MandateForm,
  },
})
export default class DisplayFieldMandate extends mixins(AbstractDisplayField) {
  $refs: {
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  public entity: any = null;
  public showForm = false;
  public showDrawerSection = false;
  public isSavingForm = false;
  public disabledForm = true;
  public permissionEntityNameToUse = 'mandates';

  get mandateId(): number | null {
    return this.value || null;
  }

  get contactId(): number | null {
    return this.item?.contact_id || null;
  }

  get subscriptionId(): number | null {
    return this.item?.id || null;
  }

  handleMandateClick(): void {
    if (!this.mandateId) return;
    this.openMandateDrawer(this.mandateId);
  }

  handleCreateMandate(): void {
    if (!this.contactId) {
      this.$bpcMessage.showErrorMessage({ text: 'global.mandate.error_no_contact.label' });
      return;
    }
    this.openCreateMandateDrawer();
  }

  openMandateDrawer(mandateId: number): void {
    const path = this.$bpcApiRouteHelper.getEntityPath('mandate') + '/' + mandateId;

    this.$bpcApi.get(path).subscribe(
      response => {
        this.entity = response.data;
        this.showForm = true;
        this.showDrawerSection = true;
        this.disabledForm = true;
      },
      () => {
        this.$bpcMessage.showErrorMessage({ text: 'global.generic.error_loading_entity.label' });
      },
    );
  }

  openCreateMandateDrawer(): void {
    this.entity = {
      contact_id: this.contactId,
      status: 'FRST',
    };

    this.showForm = true;
    this.showDrawerSection = true;
    this.disabledForm = false;
  }

  onFormSave(): void {
    this.$refs.stdForm.saveEntity();
  }

  onFormSaved(event: any): void {
    this.onFormClose();

    if (event && event.data) {
      const categoryPath =
        this.$bpcApiRouteHelper.getEntityPath('subscription-category') +
        '/' +
        this.item.subscription_category_id;

      this.$bpcApi.get(categoryPath).subscribe(
        categoryResponse => {
          const subscriptionPath =
            this.$bpcApiRouteHelper.getEntityPath('subscription') + '/' + this.subscriptionId;

          const payload = {
            id: this.item.id,
            mandate_id: event.data.id,
            subscription_category_id: this.item.subscription_category_id,
            subscriptionCategory: categoryResponse.data,
            contact_id: this.item.contact_id,
            status: this.item.status,
            code: this.item.code,
            start_date: this.item.start_date,
            remaining_credits: this.item.remaining_credits,
            notify_by_email: false,
            ...(this.item.end_date && { end_date: this.item.end_date }),
            ...(this.item.article_id && { article_id: this.item.article_id }),
          };

          this.$bpcApi.put(subscriptionPath, payload).subscribe(
            () => {
              this.$bpcMessage.showSuccessMessage({
                text: 'global.mandate.linked_success.label',
              });

              this.refreshAllSubscriptionTables();
            },
            error => {
              if (error.error?.errors) {
                const errorMessage = Object.values(error.error.errors)
                  .flat()
                  .join(', ');
                this.$bpcMessage.showErrorMessage({ text: errorMessage });
              } else if (error.error?.message) {
                this.$bpcMessage.showErrorMessage({ text: error.error.message });
              } else {
                this.$bpcMessage.showErrorMessage({ text: 'global.mandate.linked_error.label' });
              }
            },
          );
        },
        () => {
          this.$bpcMessage.showErrorMessage({
            text: 'Error fetching subscription category data',
          });
        },
      );
    }
  }

  onFormClose(): void {
    this.showForm = false;
    this.showDrawerSection = false;
  }

  onFormEdit(): void {
    this.disabledForm = false;
  }

  onSavingEntity(val: boolean): void {
    this.isSavingForm = val;
  }

  getModalTitle(): string {
    if (this.disabledForm) {
      const title = this.$t('global.models.mandate.name').toString();
      return title.charAt(0).toUpperCase() + title.slice(1);
    }
    return this.entity && this.entity.id
      ? this.$t('global.modals.edit') + ' ' + this.$t('global.models.mandate.name')
      : this.$t('global.modals.create') + ' ' + this.$t('global.models.mandate.name');
  }

  refreshAllSubscriptionTables(): void {
    const event = new CustomEvent('refresh-subscription-tables');
    window.dispatchEvent(event);

    const root = this.$root;
    this.findAndRefreshSubscriptionTables(root);
  }

  findAndRefreshSubscriptionTables(component: Vue): void {
    if (component.$options && component.$options.name === 'bpc-subscription-table') {
      if (component.$refs && component.$refs.provider) {
        const provider = component.$refs.provider as any;
        if (typeof provider.getEntities === 'function') {
          provider.getEntities();
        }
      }
    }

    if (component.$children && component.$children.length) {
      component.$children.forEach(child => {
        this.findAndRefreshSubscriptionTables(child);
      });
    }
  }
}
